import React, {forwardRef, useEffect} from 'react';

import {
    ButtonBase, Slide, Stack
} from '@mui/material';

import Icons from 'assets/icons';
import {
    Dialog, HiddenFileInput, SaveButton} from 'components';
import {imageUrl} from 'lib/media';
import {useLicenseManager} from 'module/user/useLicenseManager';
import {useLayoutStore, useSnackbarStore} from 'store';

import {useApiUpdate, useApiUpload} from './useClientApi';

import {Form, FormField, TeamColorPickerField,useForm} from 'form/index';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const styles = {
    clubLogoHolder: {
        width: '100%',
        position: 'relative',
        paddingTop: '30px',
        paddingBottom: '30px',
        '& img': {
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '750px'
        },
    },
    absolutIconBox: {
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'red.highlight',
        borderRadius: '50%',
        height: 60,
        width: 60,
    },
    absolutIconBoxWithoutImage: {
        backgroundColor: 'red.highlight',
        borderRadius: '50%',
        height: 60,
        width: 60,
    },
    uploadButton: {
        backgroundColor: 'red.highlight',
        padding: 1,
        '> svg': {
            fill: theme => theme.palette.white.main,
            width: 18,
            height: 18
        }
    },
    uploadButtonWithoutImage: {
        backgroundColor: 'red.highlight',
        '> svg': {
            fill: theme => theme.palette.white.main,
            width: 30,
            height: 30
        }
    },
    fieldContainer: {
        mb: 2
    },
    /* infoContainer: {
        marginBottom: 2,
    },
    infoLabel: {
        fontSize: '14px',
        color: 'grey.main',
        marginRight: '6px',
    },
    infoValue: {
        fontSize: '14px',
        color: 'black.main',
        background: 'white',
        padding: '0 4px',
    } */
};

const Edit = ({client, onClose, onSave}) => {

    const showInfo = useSnackbarStore((state) => state.show);

    const setShowLoading = useLayoutStore((state) => state.setShowLoading);

    const {update, loading: loading1, data, errors} = useApiUpdate(client);
    const {upload, loading: loading2} = useApiUpload();
    const {hasFullAccess} = useLicenseManager();

    const rhf = useForm(data, errors);

    const doSave = () => {
        rhf.methods.handleSubmit(async formData => {
            formData.id = client.id;
            try {
                const res = await update(formData);
                showInfo('client.action.save_success');
                onSave && onSave(res);
            } catch (e) {
                showInfo(e.message, {severity: 'warning'});
            }
        })();
    };

    const doUpload = async (e) => {
        if (e.target.files.length === 1) {
            const res = await upload(client.id, e.target.files[0]);
            e.target.value = null;
            onSave && onSave(res);
        }
    };

    useEffect(() => {
        setShowLoading(loading1 || loading2);
        return () => {
            setShowLoading(false);
        };
    }, [loading1, loading2, setShowLoading]);

    const playerColors = {
        color: rhf.watch('colors.value1') || client.colors.value1 || '#ffffff',
        bgcolor:  rhf.watch('colors.value2') || client.colors.value2 ||'#000000'
    };

    return (
        <Dialog
            maxWidth={false}
            pt={0}
            open={true}
            TransitionComponent={Transition}
            title="client.action.edit"
            handleClose={onClose}
            dividers={true}
        >

            <Stack sx={styles.clubLogoHolder} justifyContent="center" alignItems="center">
                {client.image && <img src={imageUrl(client.image, {w: 300})} alt={client.name} />}
                <Stack sx={client.image ? styles.absolutIconBox : styles.absolutIconBoxWithoutImage} alignItems="center" justifyContent="center">
                    <ButtonBase component="label" sx={client.image ? styles.uploadButton : styles.uploadButtonWithoutImage}>
                        <Icons.Camera />
                        <HiddenFileInput name="file" onChange={doUpload}/>
                    </ButtonBase>
                </Stack>
            </Stack>

            <Form methods={rhf.methods}>                                        
                <Stack direction="column" justifyContent="flex-end" p={2}>

                    {/* <Stack sx={styles.infoContainer} direction="row" alignItems="center">
                        <Typography sx={styles.infoLabel}>
                            <Text>client.info.home_or_guest</Text>:
                        </Typography>
                        <Typography sx={styles.infoValue}>
                            {client.type === 'home' ? 'Heim' : 'Gast'}
                        </Typography>
                    </Stack> */}

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="name"
                            label="client.name"
                        />
                    </Stack>

                    {hasFullAccess('colors') && (
                        <Stack>
                            <TeamColorPickerField
                                primaryColor={playerColors.color}
                                secondaryColor={playerColors.bgcolor}
                                onPrimaryColorChange={(color) => rhf.methods.setValue('colors.value1', color)}
                                onSecondaryColorChange={(color) => rhf.methods.setValue('colors.value2', color)}
                            />
                        </Stack>
                    )}

                    {/*<Stack sx={styles.fieldContainer}>*/}
                    {/*    <FormField*/}
                    {/*        name="contact.phone"*/}
                    {/*        label="global.phone"*/}
                    {/*    />*/}
                    {/*</Stack>*/}

                    {/*<Stack sx={styles.fieldContainer}>*/}
                    {/*    <FormField*/}
                    {/*        name="contact.email"*/}
                    {/*        label="global.email"*/}
                    {/*    />*/}
                    {/*</Stack>*/}

                    <SaveButton action={doSave} />

                </Stack>
            </Form>
        </Dialog>
    );
};

export default Edit;